<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex align-center justify-space-between">
        <h2>Preferenze sulle prenotazioni</h2>
        <v-btn color="primary" size="small" @click="$router.push('/bookingprefs/new')">Nuova</v-btn>
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-text-field  v-model="query.name" label="Nome" clearable></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <data-table :headers="headers" collection="bookingprefs" view-sub-path="" :viewable="false" :editable="true" deletable :query="query" @error="onListError">
          <template v-slot:item.name="{ item }">
            <a @click="$router.push('/bookingprefs/'+item._id)" ><strong>{{ item.name }}</strong></a>
          </template>

          <template v-slot:item.seats_type="{ item }">
            <v-chip class="text-white font-weight-bold text-uppercase" variant="flat" size="small" :color="getSeatsTypeColor(item.seats_type)">{{getSeatsTypeLabel(item.seats_type)}}</v-chip>
          </template>

        </data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import {defineComponent, ref, computed, watch, onMounted, inject, onBeforeUnmount, useTemplateRef} from 'vue'
import { useRouter } from 'vue-router'
import utils from '../utils'
import DataTable from "@/components/DataTable.vue";
import {type DataTableError, type Query, SeatsType} from "@/models.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Auth} from "@/plugins/auth.ts";
import type {Globals} from "@/plugins/globals.ts";
import {seatsTypesOptions} from "@/consts.ts";


export default defineComponent({
  components: {DataTable},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const router = useRouter()
    const dataTable = useTemplateRef<typeof DataTable>('dataTable')
    const query = ref<Query>({})


    let wh:any;
    onMounted(async ()=>{
      await auth.waitForLogin
      await globals.waitForInit
      /*
      await Promise.all([
        globals.refresh('categories'),
        globals.refresh('difficulties'),
      ])*/
      query.value = utils.getSessionQuery("bookingprefs")
      wh = watch(query.value, ()=>{
        utils.setSessionQuery("bookingprefs", query.value)
      }, { deep: true })
    })
    onBeforeUnmount(()=>{
      if(wh) wh();
    })
    return {
      dataTable,
      formatDateTime : utils.formatDateTime,
      query,
      headers : [
        { title : 'Nome', sortable: true, align: 'left', value : 'name' },
        { title : 'Calendario', sortable: true, align: 'left', value : 'seats_type' },
        { title : 'Limite posti', sortable: true, align: 'left', value : 'limit' },
      ],
      onListError(e:DataTableError) {
        if(e.status === 401) {
          messages.error(Msg.permissionError)
          auth.logout()
          return
        }
        messages.error(`Errore: ${e.message}`)
      },
      getSeatsTypeLabel( st:SeatsType ) {
        const opt = seatsTypesOptions.find(i => i.value === st)
        return opt?.title ?? st
      },
      getSeatsTypeColor( st:SeatsType ) {
        const opt = seatsTypesOptions.find(i => i.value === st)
        return opt?.color ?? ''
      },
    }
  }
})
</script>
